import { FingerprintjsWrapper } from "../modules/fingerprintjs/FingerprintjsWrapper";
import { CheckboxValue, RegistrationProtocol } from "../../user/registrationProtocol";
import { FormHandlers } from "../modules/formHandlers";
import { registrationV4 } from "../modules/registration_popup/registrationV4";
import { JRpcResponse } from "../modules/jsonRpc/jsonRpcResponseFactory";

async function registerThroughHubSendRequest(form: JQuery): Promise<JRpcResponse<{}>> {
    const confidenceScore = await FingerprintjsWrapper.getConfidenceScore();
    const emailField = form.find('input[type=email]');
    const email: string = (emailField.val() as string).trim();
    const passwordField = form.find('input[type=password]');
    const password: string = (passwordField.val() as string).trim();
    const state = form.find('[name=state]').val();
    const lp = form.find('[name=lp]').val() as number;
    const csrftoken = form.find('[name=csrftoken]').val() as number;
    const consentState: boolean = form.find('[name=receive_consent]')
        .prop('checked') as boolean;

    const regData: RegistrationProtocol = {
        confidence: confidenceScore,
        csrftoken,
        email,
        lp,
        password,
        receive_consent: (consentState ? 'on' : 'off') as CheckboxValue,
        state
    };

    const formAction = form.attr('action');
    const isLpReg = formAction === 'lpregistration';

    return await registrationV4(regData, isLpReg);
}

export function initRegistrationFormHandler() {
    FormHandlers.registerSendRequestHandler('registration_through_hub_send_request', registerThroughHubSendRequest);
}
